import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthenticatedMemberService, GlobalReduxStore, HomepageAvailableGameRewardVM, RewardableActionType, RewardEventCode, UpdateHomepageModulesRewards } from '@genesis-frontend/genesis-utilities';

@Injectable({
    providedIn: 'root'
})
export class HomepageModuleRewardsService {
    member = this.authenticatedMemberService.getAuthenticatedMember();

    private readonly BASE_REWARDS_PUBLIC_URL = '/rewards-api/public';

    constructor(
        private httpClient: HttpClient,
        private authenticatedMemberService: AuthenticatedMemberService,
        private mfReduxStore: GlobalReduxStore
    ) {}

    updateHealthyHabitsModuleRewards(): Observable<HomepageAvailableGameRewardVM[]> {
        return this.getHomepageModuleRewards(RewardableActionType.SelfEnteredTrackerData).pipe(
            tap((response: HomepageAvailableGameRewardVM[]) => {
                const healthyHabitModuleReward = this.getModuleRewardByEventCode(response, RewardEventCode.TKR);

                if (healthyHabitModuleReward) {
                    this.mfReduxStore.dispatchAction(UpdateHomepageModulesRewards(healthyHabitModuleReward));
                }
            })
        );
    }

    private getHomepageModuleRewards(rewardableActionType: RewardableActionType): Observable<HomepageAvailableGameRewardVM[]> {
        const params = new HttpParams().set('rewardableActionTypes', rewardableActionType);

        return this.httpClient.get<HomepageAvailableGameRewardVM[]>(
            `${this.BASE_REWARDS_PUBLIC_URL}/sponsors/${this.member.sponsorId}/members/${this.member.id}/homepage`,
            { params }
        );
    }

    private getModuleRewardByEventCode(homepageModuleRewards: HomepageAvailableGameRewardVM[], eventCode: string): HomepageAvailableGameRewardVM | undefined {
        return homepageModuleRewards.find((item: HomepageAvailableGameRewardVM) => {
            return item.eventCode === eventCode;
        });
    }
}
